export default __webpack_public_path__ + "static/media/192.29c6c02a.jpg";